<p-toast></p-toast>
<div style="background-color: rgb(0, 152, 223); height: 5px;" class="ng-star-inserted"></div>
<div class="title p-field p-col-5">
  <h4>Selecionar Banco de Dados</h4>
</div>
<div class="dropdown p-field p-col-10">
  <div class="p-col-6">
    <label for="listBanco">Banco de Dados: </label>
    <p-dropdown id="listBanco" [options]="listaBancos" [(ngModel)]="BancoSelecionado" optionLabel="nomeBanco"
      optionValue="bancoDados" placeholder="Selecione um Banco..."></p-dropdown>
  </div>
</div>
<div class="button p-col-2">
  <p-button (click)="atualizarBanco()" label="Atualizar Banco"></p-button>
</div>
<p-dialog [(visible)]="displayBasic" header="Atenção" [style]="{width: '26vw'}" [modal]="true">
  <p>Esta ação irá parar o funcionamento da aplicação por cerca de 40 segundos, e você será redirecionado
    para a tela de login. Deseja continuar?</p>
  <ng-template pTemplate="footer">
    <button pButton icon="pi pi-times" (click)="displayBasic=false" label="Não"></button>
    <button pButton icon="pi pi-check" (click)="atualizar()" label="Sim"></button>
  </ng-template>
</p-dialog>